export const LIST = "MOBILE_APP_BONUS_SETTING_LIST";
export const DROPDOWN = "MOBILE_APP_BONUS_SETTING_DROPDOWN";
export const STORE = "MOBILE_APP_BONUS_SETTING_STORE";
export const UPDATE = "MOBILE_APP_BONUS_SETTING_UPDATE";
export const DELETE = "MOBILE_APP_BONUS_SETTING_DELETE";
export const UPDATE_STATUS = "MOBILE_APP_BONUS_SETTING_UPDATE_STATUS";
export const DETAILS = "MOBILE_APP_BONUS_SETTING_DETAILS";